import React from "react";
import EditTeamButton from "../../components/teams/EditTeamButton";
import EditTeamDialog from "../../components/teams/EditTeamDialog";

class EditTeamContainer extends React.Component {
  state = {
    name: "",
    country: "none",
    email: "",
    dressingRoom: "",
    extraField: "",
    open: false,
    submitDisabled: true,
    teamList: "",
    gamertag: "",
    questions: {},
    products: {},
    teamWishes: {},
  };

  UNSAFE_componentWillMount = () => {
    this._ismounted = true;
    const team = this.props.team;
    if (team) {
      this.updateState(team);
    }
  };

  componentWillUnmount() {
    this._ismounted = false;
  }

  UNSAFE_componentWillReceiveProps = () => {
    if (this.props.team) {
      this.setState({
        email: this.props.team.email || "",
      });
    }
  };

  updateState = (team) => {
    let newState = {
      name: team.name || "",
      country: team.country || "none",
      email: team.email || "",
      dressingRoom: team.dressingRoom || "",
      extraField: team.extraField || "",
      gamertag: team.gamertag || "",
    };
    Object.keys(this.props.tournament.infoFields || {}).map((key) => {
      return (newState[key] = team[key] || "");
    });
    let questions = {};

    Object.keys(this.props.tournament.questions || {}).map((key) => {
      return (questions[key] = (team.questions || {})[key] || "");
    });
    newState["questions"] = questions;

    let products = {};

    Object.keys(this.props.tournament.products || {}).map((key) => {
      return (products[key] = (team.products || {})[key] || "");
    });
    newState["products"] = products;

    let teamWishes = {};
    Object.keys(this.props.tournament.teamWishes || {})
      .filter((p) => this.props.tournament.teamWishes[p].show)
      .forEach((key) => {
        teamWishes[key] = (team.teamWishes || {})[key] || "";
      });
    newState["teamWishes"] = teamWishes;
    this.setState(newState);
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    if (event.target.name === "name" || event.target.name === "teamList") {
      if (event.target.value.length > 0) {
        newState["submitDisabled"] = false;
      } else {
        newState["submitDisabled"] = true;
      }
    } else if (this.props.team) {
      newState["submitDisabled"] = false;
    }
    this.setState(newState);
  };

  handleQuestionChange = (event) => {
    let newState = {};
    let questions = this.state.questions;
    questions[event.target.name] = event.target.value;
    if (this.state.name.length > 0) {
      newState["submitDisabled"] = false;
    }
    newState["questions"] = questions;
    this.setState(newState);
  };

  handleProductChange = (event) => {
    let newState = {};
    let products = this.state.products;
    products[event.target.name] = event.target.value;
    if (this.state.name.length > 0) {
      newState["submitDisabled"] = false;
    }
    newState["products"] = products;
    this.setState(newState);
  };

  handleTeamWishChange = (event) => {
    let newState = {};
    let teamWishes = this.state.teamWishes;
    teamWishes[event.target.name] = event.target.value;
    if (this.state.name.length > 0) {
      newState["submitDisabled"] = false;
    }
    newState["teamWishes"] = teamWishes;
    this.setState(newState);
  };

  handleKeyDown = (e) => {
    if (e.keyCode === 9) {
      // tab was pressed
      // get caret position/selection
      var start = e.target.selectionStart;
      var end = e.target.selectionEnd;

      var target = e.target;
      var value = target.value;
      // set textarea value to: text before caret + tab + text after caret
      target.value = value.substring(0, start) + "\t" + value.substring(end);
      // put caret at right position again (add one for the tab)
      this.selectionStart = this.selectionEnd = start + 1;

      // prevent the focus lose
      e.preventDefault();
      this.handleChange(e);
    }
  };

  toggleDialog = () => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      this.setState({ open: !this.state.open });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ submitDisabled: true });
    this.toggleDialog();
    const team = {
      name: this.state.name,
      gamertag: this.state.gamertag,
      country: this.state.country,
      extraField: this.state.extraField,
      division: this.props.division.id,
      dressingRoom: this.state.dressingRoom,
      teamWishes: this.state.teamWishes,
      products: this.state.products,
    };
    // console.log(team);
    Object.keys(this.props.tournament.infoFields || {}).forEach((key) => {
      if (this.props.tournament.infoFields[key].showOnLive) {
        team[key] = this.state[key] || "";
      }
    });

    const db = window.firebase.firestore();

    // Get a new write batch
    const batch = db.batch();
    const batchTeamsAsRefs = db.batch();
    let commitBatchTeamsAsRefs = false;

    var teamRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("teams");
    var refereesRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("referees");
    if (this.props.team) {
      teamRef = teamRef.doc(this.props.team.id);
      batch.update(teamRef, team);

      if (this.props.tournament.teamsAsRefs) {
        let newRefereeDoc = refereesRef.doc(this.props.team.id);
        let newReferee = {
          name: this.state.name,
        };
        batchTeamsAsRefs.update(newRefereeDoc, newReferee);
        commitBatchTeamsAsRefs = true;
      }
    } else {
      // set created at timestamp
      team["createdAt"] =
        window.firebase.firestore.FieldValue.serverTimestamp();

      teamRef = teamRef.doc();
      batch.set(teamRef, team);

      if (this.props.tournament.teamsAsRefs) {
        let newRefereeDoc = refereesRef.doc(teamRef.id);
        let newReferee = {
          name: this.state.name,
          teamId: teamRef.id,
          excludeTeams: [teamRef.id],
        };
        batch.set(newRefereeDoc, newReferee);
      }
    }

    var teamEmailRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("teamsContactInfo")
      .doc(teamRef.id);

    let teamsContactInfo = {
      email: this.state.email,
      questions: this.state.questions,
    };
    Object.keys(this.props.tournament.infoFields || {}).forEach((key) => {
      teamsContactInfo[key] = this.state[key] || "";
    });
    batch.set(teamEmailRef, teamsContactInfo);

    // Commit the batch
    batch
      .commit()
      .then(() => {
        // console.log("committed");
        if (this._ismounted) {
          if (this.props.team) {
            if (commitBatchTeamsAsRefs) {
              batchTeamsAsRefs
                .commit()
                .then(() => {
                  this.setState({ submitDisabled: true });
                })
                .catch((error) => {
                  this.setState({ submitDisabled: true });
                });
            } else {
              this.setState({ submitDisabled: true });
            }
          } else {
            if (window.firebase.analytics) {
              window.firebase.analytics().logEvent("team_added");
            }
            let initialState = {
              submitDisabled: true,
              name: "",
              gamertag: "",
              country: "none",
              email: "",
              dressingRoom: "",
              extraField: "",
              questions: {},
              teamWishes: {},
              products: {},
            };
            Object.keys(this.props.tournament.infoFields || {}).map((key) => {
              return (initialState[key] = "");
            });
            this.setState(initialState);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ submitDisabled: false });
      });
  };

  handleSubmitMultiple = (e) => {
    e.preventDefault();
    this.setState({ submitDisabled: true });
    const db = window.firebase.firestore();
    let batch = db.batch();
    var teamRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("teams");
    let splitted = this.state.teamList.split("\n");
    let questionKeys = [];
    Object.keys(this.props.tournament.questions || {})
      .filter((key) => this.props.tournament.questions[key].perSignup !== true)
      .sort((a, b) => {
        const qA = this.props.tournament.questions[a];
        const qB = this.props.tournament.questions[b];
        if (qA.num > qB.num) {
          return 1;
        } else if (qA.num < qB.num) {
          return -1;
        } else {
          return 0;
        }
      })
      .forEach((key) => {
        if (this.props.tournament.questions[key].show) {
          questionKeys.push(key);
        }
      });
    Object.keys(this.props.tournament.questions || {})
      .filter((key) => this.props.tournament.questions[key].perSignup === true)
      .sort((a, b) => {
        const qA = this.props.tournament.questions[a];
        const qB = this.props.tournament.questions[b];
        if (qA.num > qB.num) {
          return 1;
        } else if (qA.num < qB.num) {
          return -1;
        } else {
          return 0;
        }
      })
      .forEach((key) => {
        if (this.props.tournament.questions[key].show) {
          questionKeys.push(key);
        }
      });

    let infoFieldKeys = Object.keys(this.props.tournament.infoFields || {});

    let teamsContactInfo = {};

    let numTeamsInBatch = 0;

    for (let i in splitted) {
      let split = splitted[i];
      let splittedSplit = split.split("\t");
      const trimmedName = (splittedSplit[0] || "").trim();
      if (split !== "" && split !== " " && trimmedName !== "") {
        let teamData = {
          name: trimmedName,
          division: this.props.division.id,
          createdAt: window.firebase.firestore.FieldValue.serverTimestamp(),
        };
        if (splittedSplit.length > 1) {
          let startSplit = 1;
          if (
            ((this.props.tournament.defaultFields || {})["email"] || {}).show
          ) {
            startSplit = 2;
            teamsContactInfo["email"] = splittedSplit[1];
          }

          if (
            this.props.tournament.showTeamSignupQuestion2Table !== undefined
              ? this.props.tournament.showTeamSignupQuestion2Table
              : this.props.tournament.showTeamSignupQuestion2 !== undefined
                ? this.props.tournament.showTeamSignupQuestion2
                : false
          ) {
            teamData["gamertag"] = splittedSplit[startSplit];
            startSplit++;
          }

          if (questionKeys.length > 0) {
            let questions = {};
            let answers = splittedSplit.slice(
              startSplit,
              startSplit + questionKeys.length,
            );
            for (let x in answers) {
              if (questionKeys[x]) {
                questions[questionKeys[x]] = answers[x];
              }
            }
            teamsContactInfo["questions"] = questions;
          }

          let extraFields = splittedSplit.slice(
            startSplit + questionKeys.length,
          );
          for (let x in extraFields) {
            if (infoFieldKeys[x]) {
              teamsContactInfo[infoFieldKeys[x]] = extraFields[x];

              if (
                this.props.tournament.infoFields[infoFieldKeys[x]].showOnLive
              ) {
                teamData[infoFieldKeys[x]] = extraFields[x];
              }
            }
          }
        }
        let teamDoc = teamRef.doc();
        var contactInfoRef = db
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection("teamsContactInfo");
        let contactInfoDoc = contactInfoRef.doc(teamDoc.id);
        batch.set(teamDoc, teamData);
        batch.set(contactInfoDoc, teamsContactInfo);

        if (this.props.tournament.teamsAsRefs) {
          var refereesRef = db
            .collection("tournaments")
            .doc(this.props.tournament[".key"])
            .collection("referees");
          let newRefereeDoc = refereesRef.doc(teamDoc.id);
          let newReferee = {
            name: teamData.name || "",
            teamId: teamDoc.id,
            excludeTeams: [teamDoc.id],
          };
          batch.set(newRefereeDoc, newReferee);
        }
        numTeamsInBatch++;
        if (numTeamsInBatch === 100) {
          numTeamsInBatch = 0;
          batch.commit();
          batch = db.batch();
        }
      }
    }

    if (numTeamsInBatch > 0) {
      batch
        .commit()
        .then(() => {
          if (window.firebase.analytics) {
            window.firebase.analytics().logEvent("multiple_teams_added");
          }
          if (this._ismounted) {
            let initialState = {
              submitDisabled: true,
              teamList: "",
            };
            this.setState(initialState);
            this.toggleDialog();
          }
        })
        .catch((error) => {
          this.setState({ submitDisabled: false });
        });
    } else {
      if (window.firebase.analytics) {
        window.firebase.analytics().logEvent("multiple_teams_added");
      }
      if (this._ismounted) {
        let initialState = {
          submitDisabled: true,
          teamList: "",
        };
        this.setState(initialState);
        this.toggleDialog();
      }
    }
  };

  enableSubmit = () => {
    this.setState({ submitDisabled: false });
  };

  render() {
    return (
      <div>
        <EditTeamDialog
          toggleDialog={this.toggleDialog}
          handleChange={this.handleChange}
          handleQuestionChange={this.handleQuestionChange}
          handleProductChange={this.handleProductChange}
          handleSubmit={this.handleSubmit}
          handleSubmitMultiple={this.handleSubmitMultiple}
          handleKeyDown={this.handleKeyDown}
          team={this.props.team}
          {...this.state}
          tournament={this.props.tournament}
          user={this.props.user || {}}
          enableSubmit={this.enableSubmit}
          days={this.props.days}
          handleTeamWishChange={this.handleTeamWishChange}
        />
        <EditTeamButton
          toggleDialog={this.toggleDialog}
          team={this.props.team}
          tournament={this.props.tournament}
        />
      </div>
    );
  }
}

export default EditTeamContainer;
